export default __webpack_public_path__ + "static/media/Supply.4795fb7f.svg";